import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n/useLanguage";
import { useAuth } from "@/hooks/useAuth";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="w-full max-w-md text-center">
        <div className="mb-8">
          <div className="mx-auto w-24 h-24 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mb-4">
            <svg
              className="w-12 h-12 text-red-600 dark:text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Truy cập bị từ chối
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Chỉ có quyền admin mới được truy cập vào hệ thống này. Vui lòng đăng nhập với tài khoản
            admin.
          </p>
        </div>

        <div className="space-y-3">
          <button onClick={() => navigate("/dashboard")} className="w-full btn-primary">
             Trở về Dashboard
          </button>

          <button
            onClick={() => {
              logout();
              navigate("/auth/signin");
            }}
            className="w-full btn-secondary"
          >
            Đăng nhập lại
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
